import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles, Zap, ShieldCheck, Cpu } from 'lucide-react';

export const Features: React.FC = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: <Cpu className="w-6 h-6 text-amber-500" />,
      bg: "bg-amber-100",
      title: t('features.ai.title'),
      desc: t('features.ai.desc')
    },
    {
      icon: <Zap className="w-6 h-6 text-emerald-500" />,
      bg: "bg-emerald-100",
      title: t('features.fast.title'),
      desc: t('features.fast.desc')
    },
    {
      icon: <ShieldCheck className="w-6 h-6 text-indigo-500" />,
      bg: "bg-indigo-100",
      title: t('features.secure.title'),
      desc: t('features.secure.desc')
    },
    {
      icon: <Sparkles className="w-6 h-6 text-cyan-500" />,
      bg: "bg-cyan-100",
      title: t('features.free.title'),
      desc: t('features.free.desc')
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-24 w-full max-w-6xl px-4">
      {features.map((f, i) => (
        <div key={i} className="bg-white border border-slate-200 p-6 rounded-2xl hover:shadow-xl hover:shadow-slate-200/60 hover:-translate-y-1 transition-all duration-300 group cursor-default">
          <div className={`mb-4 p-3 ${f.bg} rounded-xl w-fit group-hover:scale-110 transition-transform duration-300`}>
            {f.icon}
          </div>
          <h3 className="text-lg font-bold text-slate-900 mb-2 font-display">{f.title}</h3>
          <p className="text-slate-500 text-sm leading-relaxed font-medium">{f.desc}</p>
        </div>
      ))}
    </div>
  );
};

